import React from 'react';

export const StatCard = ({ label, value, icon }) => (
  <div className="bg-white rounded-xl p-4" style={{ border: '1px solid #E8E8E8' }}>
    <div className="flex items-center justify-between mb-1">
      <span className="text-xs font-medium" style={{ color: '#999' }}>{label}</span>
      {icon}
    </div>
    <p className="text-2xl font-bold" style={{ color: '#1A1209' }}>{typeof value === 'number' ? value.toLocaleString() : value}</p>
  </div>
);

export const DetailRow = ({ icon, label, value, valueColor }) => (
  <div className="flex items-center gap-3">
    <span style={{ color: '#BBB' }}>{icon}</span>
    <span className="text-xs w-28" style={{ color: '#999' }}>{label}</span>
    <span className="text-sm font-medium" style={{ color: valueColor || '#1A1209' }}>{value}</span>
  </div>
);

export const TimelineStep = ({ num, text, active }) => (
  <li className="flex items-start gap-3">
    <div className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0 mt-0.5"
      style={active ? { backgroundColor: '#2563EB', color: 'white' } : { backgroundColor: '#DBEAFE', color: '#93C5FD' }}>
      {num}
    </div>
    <span className="text-sm" style={{ color: active ? '#1E40AF' : '#93C5FD' }}>{text}</span>
  </li>
);

export const InfoStep = ({ num, text }) => (
  <div className="flex items-start gap-3">
    <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0" style={{ backgroundColor: '#F5831F15', color: '#F5831F' }}>
      {num}
    </div>
    <p className="text-sm" style={{ color: '#666' }}>{text}</p>
  </div>
);

export const InfoField = ({ label, value }) => (
  <div>
    <p className="text-[10px] font-medium uppercase tracking-wider mb-1" style={{ color: '#999' }}>{label}</p>
    <p className="text-sm font-medium" style={{ color: '#1A1209' }}>{value || '—'}</p>
  </div>
);
